<template>
  <div>
    <modal name="import_drop_zone" :width="500" height:='auto' :padding="20">
      <div class="outer">
        <span>バーコード読み取りデータをインポート</span>
        <div class="drop_zone"
          :class="{'enter': isEnter}"
          @dragenter="dragEnter"
          @dragleave="dragLeave"
          @dragover.prevent
          @drop.prevent="setDropFile">

          <button class="btn btn-primary" @click='pushButton()'>ファイルをドラッグ&ドロップ</button>
          <input @change='fileChange' id="file_read" style="display: none;" type="file" />
        </div>

        <table>
          <tbody>
            <tr>
              <td>今日の商品数</td>
              <td>{{itemCount}}個</td>
            </tr>
          </tbody>
        </table>
        <button class="btn btn-danger btn-sm reset-button-right" @click='resetButton()'>今日の登録データをリセット</button>
      </div>
    </modal>
  </div>
</template>

<script>
import axios from 'axios'
import importFile from '@/js/importFile.js'

export default {
  name: 'ImportForm',
  data () {
    return {
      xmlHttp: null,
      isEnter: false,
      itemCount: 0
    }
  },
  created: function () {
    axios.get('/api/barcode/import')
      .then((response) => {
        // console.log(response)
        this.itemCount = response.data.itemCount
      })
  },
  methods: {
    dragEnter () {
      this.isEnter = true
    },
    dragLeave () {
      this.isEnter = false
    },
    pushButton () {
      const button = document.getElementById('file_read')
      button.click()
    },
    resetButton () {
      if (confirm('今日の登録データを削除してよろしいですか?')) {
        axios.get('/api/barcode/delete')
          .then((response) => {
            alert('今日の登録データを削除しました')
            axios.get('/api/barcode/import')
              .then((response) => {
                this.itemCount = response.data.itemCount
              })
          })
      }
    },
    fileChange (e) {
      const files = e.target.files
      // console.log(files[0])
      importFile(files[0])
        .then((res) => {
          // console.log(res)
          axios.post('/api/barcode/import', { data: res })
            .then((response) => {
              // console.log(response)
              this.itemCount = response.data.itemCount
            })
          this.isEnter = false
        })
    },
    setDropFile () {
      // console.log(event.dataTransfer.files)
      const files = event.dataTransfer.files
      if (files.length > 0) {
        importFile(files[0])
          .then((res) => {
            // console.log(res)
            axios.post('/api/barcode/import', { data: res })
              .then((response) => {
                // console.log(response)
                this.itemCount = response.data.itemCount
              })
            this.isEnter = false
          })
      }
    }
  }
}
</script>

<style scoped>
.drop_zone {
  align-items: center;
    background-color: #f5f5f5;
    width: 50%;
    border: 2px dashed rgba(0,0,0,0.12);
    border-radius: 6px;
    font-size: 15px;
    padding: 20px 24px 20px 24px;
    margin: 0 auto;
    vertical-align: middle;
}
.outer {
  top: 10%;
  position:relative;
}
.enter {
    border: 10px dotted powderblue;
}
table {
  margin: 0 auto;
  vertical-align: middle;
  height: 100%;
  position: relative;
  overflow: scroll;
  border-collapse: collapse;
  font-family: -apple-system, BlinkMacSystemFont, "Hiragino Kaku Gothic ProN", Meiryo, sans-serif;
  table-layout: fixed;
  border: 1px dashed rgba(0,0,0,0.12);
}

.reset-button-right {
  margin: 0 0 0 auto;
}

</style>
